import { useWSModal } from "@wingspanhq/fe-component-library";
import { ModalEditWorkLogNotes } from "./index";

export const useModalEditWorkLogNotes = () =>
  useWSModal(ModalEditWorkLogNotes, {
    title: "Edit notes",
    size: "S"
  });
